import React from 'react';
import Svg, { Path } from 'react-native-svg';
import { IconProps } from 'shared/components/vxl/icon/Icon/Icon';

export default function DirectDeposit({
  iconColor,
  iconSize,
  iconAccessibilityLabel,
}: IconProps) {
  return (
    <Svg
      accessibilityLabel={iconAccessibilityLabel}
      width={iconSize}
      height={iconSize}
      viewBox="0 0 24 24"
    >
      <Path
        d="M12.4713 9.80473C12.211 10.0651 11.7889 10.0651 11.5285 9.80473L6.86185 5.13807L7.80466 4.19526L11.3333 7.72385V1.33333H12.6666V7.72385L16.1952 4.19526L17.138 5.13807L12.4713 9.80473Z"
        fill={iconColor}
      />
      <Path
        d="M13.9999 17.3333C13.9999 18.4379 13.1045 19.3333 11.9999 19.3333C10.8953 19.3333 9.99992 18.4379 9.99992 17.3333C9.99992 16.2288 10.8953 15.3333 11.9999 15.3333C13.1045 15.3333 13.9999 16.2288 13.9999 17.3333Z"
        fill={iconColor}
      />
      <Path
        d="M3.33325 12.6667C3.33325 12.2985 3.63173 12 3.99992 12H19.9999C20.3681 12 20.6666 12.2985 20.6666 12.6667V22C20.6666 22.3682 20.3681 22.6667 19.9999 22.6667H3.99992C3.63173 22.6667 3.33325 22.3682 3.33325 22V12.6667ZM4.66659 13.3333V21.3333H19.3333V13.3333H4.66659Z"
        fill={iconColor}
      />
    </Svg>
  );
}
